module.exports = __webpack_public_path__ + "assets/img/banner_bg.7184a28e.png";